import { Link } from 'react-router-dom';
import { Logo } from '../components/Logo';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/button';
import { CheckCircle2 } from 'lucide-react';

export default function VerifyEmail() {
  return (
    <div className="min-h-screen flex flex-col relative z-10" data-testid="verify-page">
      <div className="flex-1 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md text-center">
        <div className="text-primary mb-8 flex justify-center"><Logo /></div>
        <div className="rounded-2xl border border-border bg-card p-9">
          <CheckCircle2 className="h-12 w-12 text-primary mx-auto mb-4" strokeWidth={1.5} />
          <h1 className="font-heading text-2xl font-semibold tracking-tight">Email verified</h1>
          <p className="text-sm text-muted-foreground mt-2">Your account is ready. Sign in to continue.</p>
          <Link to="/login" className="mt-6 inline-block">
            <Button className="rounded-full" data-testid="verify-login-btn">Sign in</Button>
          </Link>
        </div>
      </div>
      </div>
      <Footer />
    </div>
  );
}
